import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  BotMessageListFn,
  DeleteBotMessageListFn,
  PatchBotMessageListFn,
} from "../../../Services/ChatAgent";
import {
  Button,
  Divider,
  IconButton,
  Paper,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { useMutation, useQuery } from "react-query";
import { EditIcon } from "lucide-react";
import { toast } from "react-toastify";
import { Delete, Edit } from "@mui/icons-material";
import AddChatBotMessages from "./AddChatBotMessages";

const ChatBotMessages = () => {
  const navigate = useNavigate();

  const [initialValues, setInitialValue] = useState(null);

  const [search, setSearch] = useState("");

  const { data, isLoading, refetch } = useQuery(["bot_messages", search], () =>
    BotMessageListFn({ store_id: localStorage.getItem("store_id"), search })
  );

  const AgentQA = data?.data?.data || [];

  const { mutate: DeleteQa } = useMutation(DeleteBotMessageListFn, {
    onSuccess: (res) => {
      if (res?.data?.response_code === 200) {
        toast.success(res?.data?.message);
        refetch();
      } else {
        toast.warn(res?.data?.message);
      }
    },
  });

  const { mutate: UpdateQa, isLoading: UpdateLoading } = useMutation(
    PatchBotMessageListFn,
    {
      onSuccess: (res) => {
        if (res?.data?.response_code === 200) {
          toast.success(res?.data?.message);

          refetch();
        } else {
          toast.warn(res?.data?.message);
        }
      },
    }
  );

  if (isLoading) {
    return <p className="text-center p-4">Loading...</p>;
  }

  return (
    <div className=" w-full">
      {" "}
      <div className="w-full p-4 rounded-lg border bg-deepBlue  border-gray-300 ">
        <div className="flex items-center p-2 h-14  border-zinc-600  justify-between">
          <input
            type="text"
            value={search}
            className="!border-3 !border-black !w-64 px-2 rounded-md py-1"
            placeholder="search"
            style={{ border: "1px solid black" }}
            onChange={(event) => setSearch(event.target.value)}
          />

          <AddChatBotMessages
            initialValues={initialValues}
            setInitialValue={setInitialValue}
            refetch={refetch}
          />
        </div>
        <Divider />
        <div className="w-full overflow-auto ">
          <TableContainer
            component={Paper}
            sx={{
              maxHeight: 440,
              backgroundColor: "transparent",
              overflowX: "auto",
            }}
            className="!bg-transparent"
          >
            <Table
              size="small"
              stickyHeader
              sx={{ backgroundColor: "transparent" }}
            >
              <TableHead sx={{ backgroundColor: "#2b0175" }}>
                <TableRow sx={{ backgroundColor: "#2b0175" }}>
                  <TableCell
                    align="center"
                    sx={{
                      borderRight: "1px solid #D0D0D0",
                      fontFamily: "'Poppins', sans-serif",
                      fontWeight: "bold",
                      color: "#fff",
                      backgroundColor: "#2b0175",
                    }}
                  >
                    #
                  </TableCell>
                  <TableCell
                    align="center"
                    sx={{
                      borderRight: "1px solid #D0D0D0",
                      fontFamily: "'Poppins', sans-serif",
                      fontWeight: "bold",
                      color: "#fff",
                      backgroundColor: "#2b0175",
                    }}
                  >
                    Questions
                  </TableCell>

                  <TableCell
                    align="center"
                    sx={{
                      borderRight: "1px solid #D0D0D0",
                      fontFamily: "'Poppins', sans-serif",
                      fontWeight: "bold",
                      color: "#fff",
                      backgroundColor: "#2b0175",
                    }}
                  >
                    Status
                  </TableCell>

                  <TableCell
                    align="center"
                    sx={{
                      borderRight: "1px solid #D0D0D0",
                      fontFamily: "'Poppins', sans-serif",
                      fontWeight: "bold",
                      color: "#fff",
                      backgroundColor: "#2b0175",
                    }}
                  >
                    Action
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody className="!overflow-y-auto !vh-[100%]">
                {AgentQA &&
                  AgentQA?.map((row, index) => (
                    <TableRow
                    //   sx={{
                    //     "&:last-child td, &:last-child th": { border: 0 },
                    //   }}

                    sx={{color:"#000000"}}
                    >
                      <TableCell
                        align="center"
                        sx={{
                          backgroundColor: "transparent",
                         
                          borderRight: "1px solid #D0D0D0",
                        }}
                        className="text-xs"
                      >
                        {index + 1}
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{
                          backgroundColor: "transparent",
                         
                          borderRight: "1px solid #D0D0D0",
                        }}
                        className="text-xs"
                      >
                        {row?.question || "--"}
                      </TableCell>

                      <TableCell
                        align="center"
                        sx={{
                          backgroundColor: "transparent",
                         
                          borderRight: "1px solid #D0D0D0",
                        }}
                        className="text-xs"
                      >
                        <Switch
                          color="error"
                          checked={row?.status}
                          onChange={() =>
                            UpdateQa({
                              q_id: row?.id,
                              store: localStorage.getItem("store_id"),
                              status: row?.status ? "False" : "True",
                            })
                          }
                        />
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{
                          backgroundColor: "transparent",
                         
                          borderRight: "1px solid #D0D0D0",
                        }}
                        className="text-xs"
                      >
                        <div className=" flex items-center gap-3 justify-center">
                          <IconButton
                            onClick={() => DeleteQa({ q_id: row?.id })}
                          >
                            <Delete color="error" />
                          </IconButton>
                          <IconButton onClick={() => setInitialValue(row)}>
                            <Edit color="success" />
                          </IconButton>
                        </div>
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
      </div>
    </div>
  );
};

export default ChatBotMessages;
